import { render } from "./CollectionPanelFilters.vue?vue&type=template&id=1026503c&scoped=true"
import script from "./CollectionPanelFilters.vue?vue&type=script&lang=js"
export * from "./CollectionPanelFilters.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=1026503c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1026503c"]])

export default __exports__